<template>
  <div id="PhysicalHealthPage"
       class="container-fluid has-action-bar has-footer">
    <ActionBar title="گزارش سلامت جسمانی"></ActionBar>
    <div class="row">
      <div class="col-12 col-sm-6 col-md-4">
        <div><i class="fas fa-calendar-check pl-1"></i><span class="font12px">انتخاب روز:</span></div>
        <v-menu
            v-model="menu2"
            :close-on-content-click="false"
            :nudge-right="40"
            min-width="auto"
            offset-y
            transition="scale-transition">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="inputDate2"
                v-bind="attrs"
                v-on="on"
                append-icon="mdi-calendar"
                class="input-border"
                dense
                hide-details
                readonly
                solo></v-text-field>
          </template>
          <v-date-picker
              v-model="date2"
              locale="fa-ir"
              width="256"
              @input="inputDatePicker2"></v-date-picker>
        </v-menu>
      </div>
      <div class="col-6 col-sm-4 col-md-2 text-left align-self-end">
        <v-btn block class="px-8" color="primary" rounded @click="search">
          جستجو
        </v-btn>
      </div>
    </div>
    <div class="row container mx-auto no-gutters p-0 mt-10">
      <div v-if="dataLoading" class="col-12 mt-10 col-md-6 col-lg-3 mx-auto text-center">
        در حال جستجو
        <v-progress-linear
            color="deep-purple accent-4"
            height="6"
            indeterminate
            rounded
        ></v-progress-linear>
      </div>
      <div v-else-if="isLoaded" class="col-12 col-sm-10  mx-auto ">
        <div v-if="!hasReport" class="mx-2 mt-5">
          <div class="col-12">
            <v-alert
                border="bottom"
                class="text-center"
                color="forth"
                dark>
              گزارشی برای تاریخ انتخاب شده وجود ندارد.
            </v-alert>
          </div>
        </div>
        <div v-else>
          <MultipleBarChart v-if="isChartLoaded"
                            :chart-label="loadChartLabel()"
                            :chart-standard-data="loadChartStandardData()"
                            :chart-user-data="loadChartUSerData()"
                            :standard-label="'مقداری که باید انجام شود'"
                            :user-label="'مقدار انجام شده'"/>
        </div>
      </div>
    </div>
    <FooterMenu/>
  </div>

</template>

<script>
import ActionBar from "../../components/ActionBar";
import FooterMenu from "../../components/FooterMenu";
import MultipleBarChart from "../../components/MultipleBarChart";
import moment from "moment-jalaali";

export default {
  name: "PhysicalHealth",
  metaInfo: {
    title: 'مسیربرتر-گزارش سلامت جسمانی'
  },
  components: {MultipleBarChart, FooterMenu, ActionBar},
  data: function () {
    return {
      inputDate2: '',
      date2: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu2: false,
      openMonthPicker: false,
      showMonthPicker: false,
      years: [],
      selectedYear: null,
      dataLoading: false,
      isChartLoaded: false,
      isLoaded: false,
      hasReport: false,
      selectedMonth: null,
      startDate: null,
      endDate: null,
      items: [
        {
          EffectEsteghamatAzolani: '111.8', TotalEffectEsteghamatAzolani: '1430.4',
          EffecttGhalbiTanafosi: '111.8', TotalEffecttGhalbiTanafosi: '1430.4',
          EffectGhodrateAzolani: '111.8', TotalEffectGhodrateAzolani: '1430.4',
          EffectEnetafPaziri: '111.8', TotalEffectEnetafPaziri: '1430.4',
        },

      ],
      chartUserData: [],
      chartLabel: ['استقامت عضلانی', 'استقامت قلبی تنفسی', 'قدرت عضلانی', 'انعطاف پذیری'],
      chartStandardData: []
    }
  },
  mounted() {
    this.inputDate2 = this.$convertDate(this.date2)


  },
  methods: {
    inputDatePicker2() {
      this.menu2 = false
      this.inputDate2 = moment(this.date2).format('jYYYY/jMM/jDD')
    },

    search() {
      this.dataLoading = true;
      let myHeaders = new Headers();
      myHeaders.append("Authorization", this.$getUserData().token);
      myHeaders.append("Content-Type", "application/x-www-form-urlencoded");

      let urlencoded = new URLSearchParams();
      urlencoded.append("StartDate",  this.inputDate2);
      urlencoded.append("EndDate",  this.inputDate2);
      urlencoded.append("StudentProfileID", this.$getUserData().studentID);

      let requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow'
      };

      fetch(this.$baseUrl + "ReportManagement/_PhysicalHealth", requestOptions)
          .then(response => response.text())
          .then(result => {
            let json = JSON.parse(result)
            this.isLoaded = true
            if (json.length > 0) {
              this.hasReport = true
              this.isChartLoaded = true
              let item = json[0]
              let standardData = []
              let userData = []

              standardData.push(item.TotalEffectEsteghamatAzolani,item.TotalEffecttGhalbiTanafosi,item.TotalEffectGhodrateAzolani,item.TotalEffectEnetafPaziri)
              userData.push(item.EffectEsteghamatAzolani,item.EffecttGhalbiTanafosi,item.EffectGhodrateAzolani,item.EffectEnetafPaziri)

              this.chartUserData = userData

              this.chartStandardData = standardData

            } else {
              this.hasReport = false
            }

            this.dataLoading = false
          })
          .catch(error => console.log('error', error));
    },
    loadChartStandardData() {
      let arr = this.chartStandardData;
      let res = [];
      for (let i = 0; i < arr.length; i++) {
        res.push(arr[i]);
      }
      return res;

    },
    loadChartUSerData() {
      let arr = this.chartUserData;
      let res = [];
      for (let i = 0; i < arr.length; i++) {
        res.push(arr[i]);
      }
      return res;

    },
    loadChartLabel() {
      let arr = this.chartLabel;
      let res = [];
      for (let i = 0; i < arr.length; i++) {
        res.push(arr[i]);
      }
      return res;

    },
  }
}
</script>

<style scoped>

</style>
